const NAMESPACE = "signatureRequest";

const KEYS = {
    eSignatureStatusHeader: "eSignatureStatusHeader",
    manageSignaturesBtnLabel: "manageSignaturesBtnLabel",
    notificationsResentMsg: "notificationsResentMsg",
    requestSignaturesButtonLabel: "requestSignaturesButtonLabel",
    signatureOptionsHeader: "signatureOptionsHeader",
    cancelSignaturesHeader: "cancelSignaturesHeader",
    aboutToCancelMessage: "aboutToCancelMessage",
    closeBtnLabel: "closeBtnLabel",
    outForSigningStatusMessage: "outForSigningStatusMessage",
    readyForSignatureStatusMessage: "readyForSignatureStatusMessage",
    notPreviewedStatusMessage: "notPreviewedStatusMessage",
    missingEmailPrompt: "missingEmailPrompt",
    requestingSignaturesWaitMessage: "requestingSignaturesWaitMessage",
    cancellingSignaturesWaitMessage: "cancellingSignaturesWaitMessage",
    resendingSignaturesWaitMessage: "resendingSignaturesWaitMessage"
};

const MESSAGES = {
    [KEYS.eSignatureStatusHeader]: {
        value: "eSignature Status",
        comment: "Header for eSignature element"
    },
    [KEYS.manageSignaturesBtnLabel]: {
        value: "Manage eSignature Request",
        comment: "Label for the button to show options around the eSignature request"
    },
    [KEYS.notificationsResentMsg]: {
        value: "Notifications Resent!",
        comment: "Text to display indicating that notifications have been resent for the envelope"
    },
    [KEYS.requestSignaturesButtonLabel]: {
        value: "Request Signatures",
        comment: "Button which sends out signature requests"
    },
    [KEYS.cancelSignaturesHeader]: {
        value: "Cancel Signatures",
        comment: "Header for cancel signatures section"
    },
    [KEYS.signatureOptionsHeader]: {
        value: "Signature Request Options",
        comment: "Header for the eSignature options dialog"
    },
    [KEYS.aboutToCancelMessage]: {
        value: "You are about to cancel signature requests. All canceled documents will need to be re-signed.",
        comment: "Message explaining what will happen if signatures are canceled."
    },
    [KEYS.closeBtnLabel]: {
        value: "Close",
        comment: "Label for a button to close the signature options dialog"
    },
    [KEYS.outForSigningStatusMessage]: {
        value: "Out for signing",
        comment: "Status message for when a signature has been requested"
    },
    [KEYS.readyForSignatureStatusMessage]: {
        value: "Ready for signature",
        comment: "Status message for when a signature is ready"
    },
    [KEYS.notPreviewedStatusMessage]: {
        value: "Not yet previewed",
        comment: "Status message for when a signature has not been requested and is not ready"
    },
    [KEYS.missingEmailPrompt]: {
        value: "Please enter a valid email address",
        comment: "Status message for when no signatory email has been supplied"
    },
    [KEYS.requestingSignaturesWaitMessage]: {
        value: "Requesting Signatures...",
        comment: "Message to display while requesting signatures process is underway"
    },
    [KEYS.cancellingSignaturesWaitMessage]: {
        value: "Cancelling Signatures...",
        comment: "Message to display while signature cancellation process is underway"
    },
    [KEYS.resendingSignaturesWaitMessage]: {
        value: "Resending...",
        comment: "Message to display while resending eSignature notifications"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
